import { render, staticRenderFns } from "./SellingStrategy.vue?vue&type=template&id=d1ed5bb8&scoped=true"
import script from "./SellingStrategy.vue?vue&type=script&lang=js"
export * from "./SellingStrategy.vue?vue&type=script&lang=js"
import style0 from "./SellingStrategy.vue?vue&type=style&index=0&id=d1ed5bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ed5bb8",
  null
  
)

export default component.exports